import { ApolloClient } from 'apollo-client';
import {
  GET_P3_CONFIGURATION,
  DUPLICATE_P3CONFIGURATION_MUTATION,
  SAVE_P3CONFIGURATION_MUTATION,
  DELETE_P3CONFIGURATION_MUTATION,
  ASSIGN_P3CONFIGURATION_MUTATION,
  GET_P3_CONFIGURATIONS_REDUCED,
  DELETE_P3CONFIGURATION_FROM_CAMPAIGN_MUTATION
} from 'containers/P3ConfigurationsContainer';
import {
  P3Configuration,
  P3ConfigurationCategory,
  P3ConfigurationRegion
} from 'models/interfaces/P3Configurations';

const getP3Configuration = async (client: ApolloClient<any>, p3_configuration_id: string) => {
  return await client.query({
    query: GET_P3_CONFIGURATION,
    variables: { p3_configuration_id: p3_configuration_id }
  });
};

const getP3Configurations = async (client: ApolloClient<any>) => {
  return await client.query({
    query: GET_P3_CONFIGURATIONS_REDUCED
  });
};

const saveP3Configurations = async (
  client: ApolloClient<any>,
  p3Configuration: P3Configuration
) => {
  return await client.mutate({
    mutation: SAVE_P3CONFIGURATION_MUTATION,
    variables: {
      p3Configuration: {
        p3_configuration_id: p3Configuration.p3_configuration_id,
        p3_campaign_id: p3Configuration.p3_campaign_id,
        configuration_status_id: p3Configuration.configuration_status_id,
        tgrams_id: p3Configuration.tgrams_id,
        name: p3Configuration.name,
        description: p3Configuration.description,
        rank_points: p3Configuration.rank_points,
        coverage_areas: p3Configuration.coverage_areas,
        preview_ads: p3Configuration.preview_ads,
        program_value: p3Configuration.program_value,
        start_date: p3Configuration.start_date,
        end_date: p3Configuration.end_date
      }
    }
  });
};

const duplicateP3Configuration = async (
  client: ApolloClient<any>,
  p3_configuration_id: string,
  newConfigurationId?: string,
  newCampaignId?: string,
  tgrams_id?: string,
  refetchQueries?: any[],
  postMutateFunc?: () => any
) => {
  if (typeof refetchQueries === 'undefined' || refetchQueries.length === 0) {
    refetchQueries = [
      {
        query: GET_P3_CONFIGURATIONS_REDUCED
      }
    ];
  }

  const response = await client.mutate({
    mutation: DUPLICATE_P3CONFIGURATION_MUTATION,
    variables: { p3_configuration_id, newConfigurationId, newCampaignId },
    refetchQueries
  });

  if (typeof postMutateFunc === 'function') {
    postMutateFunc();
  }

  return response;
};

const asssignP3Configuration = async (
  client: ApolloClient<any>,
  p3_configuration_id: string,
  tgrams_id: string,
  name: string,
  refetchQueries: any[],
  postMutateFunc?: () => any
) => {
  const response = await client.mutate({
    mutation: ASSIGN_P3CONFIGURATION_MUTATION,
    variables: { p3_configuration_id, tgrams_id, name },
    refetchQueries
  });

  if (typeof postMutateFunc === 'function') {
    postMutateFunc();
  }

  return response;
};

const deleteP3Configuration = async (
  client: ApolloClient<any>,
  p3_configuration_id: string,
  refetchQueries?: any[],
  postMutateFunc?: () => any
) => {
  if (typeof refetchQueries === 'undefined' || refetchQueries.length === 0) {
    refetchQueries = [
      {
        query: GET_P3_CONFIGURATIONS_REDUCED
      }
    ];
  }

  const response = await client.mutate({
    mutation: DELETE_P3CONFIGURATION_MUTATION,
    variables: { p3_configuration_id },
    refetchQueries
  });

  if (typeof postMutateFunc === 'function') {
    postMutateFunc();
  }

  return response;
};

const deleteP3ConfigurationFromCampaign = async (
  client: ApolloClient<any>,
  p3_configuration_id: string,
  p3_campaign_id: string,
  refetchQueries?: any[],
  postMutateFunc?: () => any
) => {
  if (typeof refetchQueries === 'undefined' || refetchQueries.length === 0) {
    refetchQueries = [
      {
        query: GET_P3_CONFIGURATIONS_REDUCED
      }
    ];
  }

  const response = await client.mutate({
    mutation: DELETE_P3CONFIGURATION_FROM_CAMPAIGN_MUTATION,
    variables: { p3_configuration_id, p3_campaign_id },
    refetchQueries
  });

  if (typeof postMutateFunc === 'function') {
    postMutateFunc();
  }

  return response;
};

const createFullConfigCategories = (categories: P3ConfigurationCategory[]) => {
  return categories.map((cat: P3ConfigurationCategory) => {
    return {
      p3_configuration_id: cat.p3_configuration_id,
      category_name: cat.category_name,
      category_id: cat.category_id,
      national_purchased_rank_points: cat.national_purchased_rank_points,
      national_earned_rank_points: cat.national_earned_rank_points,
      national_bonus_rank_points: cat.national_bonus_rank_points,
      national_total_rank_points: cat.national_total_rank_points,
      national_estimated_rank: cat.national_estimated_rank,
      regional_purchased_rank_points: cat.regional_purchased_rank_points,
      regional_earned_rank_points: cat.regional_earned_rank_points,
      regional_bonus_rank_points: cat.regional_bonus_rank_points,
      regional_total_rank_points: cat.regional_total_rank_points,
      regional_estimated_ranks: cat.regional_estimated_ranks,
      has_national_preview_ad: cat.has_national_preview_ad,
      has_regional_preview_ad: cat.has_regional_preview_ad
    };
  });
};

const createFullConfigRegions = (regions: P3ConfigurationRegion[]) => {
  return regions.map((region: P3ConfigurationRegion) => {
    return {
      p3_configuration_id: region.p3_configuration_id,
      region_code: region.region_code,
      name: region.name
    };
  });
};

const createFullConfiguration = (p3Configuration: P3Configuration) => {
  return {
    name: p3Configuration.name,
    p3_configuration_id: p3Configuration.p3_configuration_id,
    p3_campaign_id: '',
    description: p3Configuration.description,
    rank_points: p3Configuration.rank_points,
    coverage_areas: p3Configuration.coverage_areas,
    preview_ads: p3Configuration.preview_ads,
    configuration_status_id: p3Configuration.configuration_status_id,
    program_value: p3Configuration.program_value
  };
};

export {
  getP3Configuration,
  getP3Configurations,
  duplicateP3Configuration,
  createFullConfigCategories,
  createFullConfigRegions,
  createFullConfiguration,
  deleteP3Configuration,
  deleteP3ConfigurationFromCampaign,
  saveP3Configurations,
  asssignP3Configuration
};
